module.exports = __webpack_public_path__ + "img/1361445893.c64532e7.jpg";